import { Directive, OnDestroy, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { Actions, ofActionSuccessful, Store } from '@ngxs/store';
import { ResetPassword, ResetPasswordFail, ResetPasswordModel, ResetPasswordSuccess } from 'gp-auth';
import {
  RtFormLabelsFromForm,
  RtFormPlaceholdersFromForm,
  RtValidationMessagesFromForm,
  RtValidatorsShared
} from 'rt-inputs';
import { Subscription } from 'rxjs';

@Directive({
  standalone: true
})
export abstract class ResetPasswordDirective implements OnInit, OnDestroy {
  readonly subscription = new Subscription();

  public form = new FormGroup({
    password: new FormControl('', [Validators.required, Validators.maxLength(200)]),
    confirmPassword: new FormControl('', [Validators.required, Validators.maxLength(200), RtValidatorsShared.matchOtherValidator('password')])
  });

  public labels: RtFormLabelsFromForm<typeof this.form> = {
    password: `Password`,
    confirmPassword: `Confirm password`
  };

  public validationMessages: RtValidationMessagesFromForm<typeof this.form> = {
    password: {
      required: `Password is required`,
      maxlength: `Password should not be more than 200 characters`
    },
    confirmPassword: {
      required: `Confirm password is required`,
      notMatch: `Passwords do not match`
    }
  };

  public placeholders: RtFormPlaceholdersFromForm<typeof this.form> = {
    password: `Enter password`,
    confirmPassword: `Confirm password`
  };

  protected constructor(protected store: Store, protected actions$: Actions, protected token: string) {
  }

  ngOnInit() {
    this.subscription.add(
      this.actions$.pipe(ofActionSuccessful(ResetPasswordSuccess, ResetPasswordFail))
        .subscribe({
          next: () => {
            this.form.enable({ emitEvent: false });
          }
        })
    );

  }

  changePassword() {
    if (this.form.valid) {
      this.store.dispatch(new ResetPassword(this.form.value as ResetPasswordModel, this.token));
      this.form.disable({ emitEvent: false });
    }
  }

  ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }

}
